export const OrganizationalCommunityInternationalServices = {
  "label": "Organizational Community International Services",
  "value": [
    {
      "code": "TC-5500.4000",
      "keyword": "LGBTQ2+ Community Centers"
    },
    {
      "code": "TC-5500.8000",
      "keyword": "Senior Centers"
    },
    {
      "code": "TD-1100.1400",
      "keyword": "Community Action Agencies"
    },
    {
      "code": "TD-1100.1500",
      "keyword": "Community Development Block Grant Agencies"
    },
    {
      "code": "TD-1100.6500-050",
      "keyword": "Area Agencies on Aging"
    },
    {
      "code": "TD-1200",
      "keyword": "Charities\/Grantmaking Organizations"
    },
    {
      "code": "TD-1400",
      "keyword": "Civic Groups"
    },
    {
      "code": "TD-1600.2600",
      "keyword": "Homelessness Advocacy Groups"
    },
    {
      "code": "TD-1600.3100-140",
      "keyword": "Children's Rights Groups"
    },
    {
      "code": "TD-1600.3100-160",
      "keyword": "Constitutional\/Civil Rights Groups"
    },
    {
      "code": "TD-1600.3100-175",
      "keyword": "Death With Dignity Advocacy Groups"
    },
    {
      "code": "TD-1600.3100-180",
      "keyword": "Disability Rights Groups"
    },
    {
      "code": "TD-1600.3100-400",
      "keyword": "LGBTQ2+ Advocacy Groups"
    },
    {
      "code": "TD-6500",
      "keyword": "Planning\/Coordinating\/Advisory Groups"
    },
    {
      "code": "BD-2600.1500",
      "keyword": "Community Gardening"
    },
    {
      "code": "BD-2600.3000",
      "keyword": "Home Gardening Assistance\/Supplies"
    },
    {
      "code": "FF-0500.1300",
      "keyword": "Community Service Work Programs"
    },
    {
      "code": "FF-0500.1300-200",
      "keyword": "Court Ordered Community Service Sites"
    },
    {
      "code": "FN-1500.1550",
      "keyword": "Community Crime Prevention Programs"
    },
    {
      "code": "FN-4000",
      "keyword": "Law Enforcement Community Engagement\/Outreach"
    },
    {
      "code": "PL-7600.3000",
      "keyword": "Historic Places"
    },
    {
      "code": "PL-7600.5500",
      "keyword": "Memorials\/Monuments"
    },
    {
      "code": "PL-7700.1300",
      "keyword": "Community Celebrations\/Festivals"
    },
    {
      "code": "PS-8000",
      "keyword": "Social Clubs\/Events"
    },
    {
      "code": "PS-8000.3000",
      "keyword": "Health\/Disability Related Social Clubs"
    },
    {
      "code": "PS-8000.4000",
      "keyword": "LGBTQ2+ Social Clubs"
    },
    {
      "code": "PS-9800.1000",
      "keyword": "Boys\/Girls Clubs"
    },
    {
      "code": "PS-9800.8500",
      "keyword": "Scouting Programs"
    },
    {
      "code": "PS-9800.9650",
      "keyword": "Y Facilities"
    },
    {
      "code": "PS-9800.9900",
      "keyword": "Youth Enrichment Programs"
    },
    {
      "code": "PV-6500",
      "keyword": "Places of Worship"
    },
    {
      "code": "PW",
      "keyword": "Volunteer Development"
    },
    {
      "code": "PW-9000",
      "keyword": "Volunteer Recruitment\/Placement"
    },
    {
      "code": "PX",
      "keyword": "Volunteer Opportunities"
    },
    {
      "code": "PX-2300.1700-500",
      "keyword": "Mentoring Services Volunteer Opportunities"
    },
    {
      "code": "ND-6500.8000",
      "keyword": "Senior Community Service Employment Programs"
    },
    {
      "code": "TB-0900.1000-600",
      "keyword": "Nonprofit Organization Financing"
    },
    {
      "code": "TN-6500",
      "keyword": "Nonprofit\/Philanthropic Associations"
    },
    {
      "code": "TB-0900.1000-600",
      "keyword": "Nonprofit Organization Financing"
    },
    {
      "code": "TN-6500",
      "keyword": "Nonprofit\/Philanthropic Associations"
    },
    {
      "code": "PH-8000",
      "keyword": "Street Outreach Programs"
    },
    {
      "code": "PH-2360.2400",
      "keyword": "Family Support Centers\/Outreach"
    },
    {
      "code": "TA-1550",
      "keyword": "Cultural Heritage Programs"
    },
    {
      "code": "TA-3000.4500",
      "keyword": "Local History Programs"
    },
    {
      "code": "TA-5500",
      "keyword": "Museums"
    },
    {
      "code": "TA-5500.7500",
      "keyword": "Planetariums\/Observatories"
    },
    {
      "code": "TA-6800",
      "keyword": "Performing Arts Facilities"
    },
    {
      "code": "TA-8500",
      "keyword": "Theater Performances"
    },
    {
      "code": "YY",
      "keyword": "Volunteers"
    },
    {
      "code": "YY-8000",
      "keyword": "HOLIDAYS"
    },
  ]
}
